export const EXCEPTIONS_SOURCES_BEGIN_UPLOAD = 'EXCEPTIONS_SOURCES_BEGIN_UPLOAD';
export const EXCEPTIONS_TOGGLE_UPLOAD_DIALOG = 'EXCEPTIONS_TOGGLE_UPLOAD_DIALOG';
export const EXCEPTIONS_SOURCES_UPLOAD_SUCCESS = 'EXCEPTIONS_SOURCES_UPLOAD_SUCCESS';
export const EXCEPTIONS_SOURCES_UPLOAD_ERROR = 'EXCEPTIONS_SOURCES_UPLOAD_ERROR';
